'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'

import classNames from 'classnames'

import { useBreadcrumbsStore } from '@/modules/breadcrumbs/hooks/use-breadcrumbs'
import PlusIcon from '../icons/PlusIcon'
import Card from './Card'

import { COLORS } from '@/utils/constants/colors'

export const Breadcrumbs = () => {
  const { currentRouteName } = useBreadcrumbsStore()
  const pathname = usePathname()
  const segments = pathname.split('/').filter(Boolean)

  return (
    <Card className="hidden lg:flex !flex-row items-center p-8 gap-x-6 border border-KMRSx24-Orange rounded-3xl w-max">
      <PlusIcon size={20} color={COLORS['KMRSx24-Orange']} />
      <ul className="flex flex-row items-center">
        {segments.map((segment, index) => {
          const href = '/' + segments.slice(0, index + 1).join('/')
          const isLast = index === segments.length - 1

          let formatted = decodeURIComponent(segment.replace(/-/g, ' '))
          if (index === segments.length - 1 && currentRouteName) {
            if (segments.includes('leistungen') && segments[segments.length - 1] !== 'leistungen') {
              formatted = currentRouteName
            }
            if (segments.includes('projekte') && segments[segments.length - 1] !== 'projekte') {
              formatted = currentRouteName
            }
            if (segments.includes('news') && segments[segments.length - 1] !== 'news') {
              formatted = currentRouteName
            }
          }
          return isLast ? (
            <li key={index} className={classNames('flex flex-row items-center text-white text-lg leading-none', { ['capitalize']: formatted !== currentRouteName })}>
              {formatted}
            </li>
          ) : (
            <li key={index} className="flex flex-row items-center">
              <Link href={href} className={classNames('font-medium text-white text-lg leading-none capitalize')}>
                {formatted}
              </Link>
              <span className="mx-1">-</span>
            </li>
          )
        })}
      </ul>
    </Card>
  )
}
